import Action from 'actions';
import Popup from 'components/molecules/modal-windows/popup';
import React from 'react';

export function showPopup(content, popupProps = {}) {
    return Action.do('openModal', <Popup {...popupProps}>{content}</Popup>);
}

export function showComponentInPopup(ContentComponent, componentProps = {}, popupProps = {}) {
    return showPopup(<ContentComponent {...componentProps} />, popupProps);
}

export function closePopup() {
    return Action.do('closeModal');
}
